import { render, staticRenderFns } from "./MediumWidget.vue?vue&type=template&id=7ac1d640&scoped=true&"
import script from "./MediumWidget.vue?vue&type=script&lang=js&"
export * from "./MediumWidget.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./MediumWidget.vue?vue&type=style&index=0&id=7ac1d640&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7ac1d640",
  null
  ,true
)

export default component.exports